export const majorOptions = [
  {value: 'Anthropology (B.A.)', label: 'Anthropology (B.A.)'},
  {value: 'Biological Anthropology (B.S.)', label: 'Biological Anthropology (B.S.)'},
  {value: 'Bioengineering (B.S.)', label: 'Bioengineering (B.S.)'},
  {value: 'Bioengineering (Biotechnology) (B.S.)', label: 'Bioengineering (Biotechnology) (B.S.)'},
  {value: 'Bioengineering (Bioinformatics) (B.S.)', label: 'Bioengineering (Bioinformatics) (B.S.)'},
  {value: 'Bioengineering: BioSystems (B.S.)', label: 'Bioengineering: BioSystems (B.S.)'},
  {value: 'Biology with Specialization in Bioinformatics (B.S.)', label: 'Biology with Specialization in Bioinformatics (B.S.)'},
  {value: 'Ecology, Behavior and Evolution (B.S.)', label: 'Ecology, Behavior and Evolution (B.S.)'},
  {value: 'General Biology (B.S.)', label: 'General Biology (B.S.)'},
  {value: 'Human Biology (B.S.)', label: 'Human Biology (B.S.)'},
  {value: 'Microbiology (B.S.)', label: 'Microbiology (B.S.)'},
  {value: 'Molecular and Cell Biology (B.S.)', label: 'Molecular and Cell Biology (B.S.)'},
  {value: 'Neurobiology (B.S.)', label: 'Neurobiology (B.S.)'},
  {value: 'Biochemistry (B.S.)', label: 'Biochemistry (B.S.)'},
  {value: 'Chemistry (B.S.)', label: 'Chemistry (B.S.)'},
  {value: 'Environmental Chemistry (B.S.)', label: 'Environmental Chemistry (B.S.)'},
  {value: 'Molecular Synthesis (B.S.)', label: 'Molecular Synthesis (B.S.)'},
  {value: 'Pharmacological Chemistry (B.S.)', label: 'Pharmacological Chemistry (B.S.)'},
  {value: 'Chinese Studies (B.A.)', label: 'Chinese Studies (B.A.)'},
  {value: 'Classical Studies (B.A.)', label: 'Classical Studies (B.A.)'},
  {value: 'Cognitive Science (B.S.)', label: 'Cognitive Science (B.S.)'},
  {value: 'Cognitive and Behavioral Neuroscience (B.S.)', label: 'Cognitive and Behavioral Neuroscience (B.S.)'},
  {value: 'Communication (B.A.)', label: 'Communication (B.A.)'},
  {value: 'Computer Engineering (B.S.)', label: 'Computer Engineering (B.S.)'},
  {value: 'Computer Science (B.S.)', label: 'Computer Science (B.S.)'},
  {value: 'Computer Science with Specialization in Bioinformatics (B.S)', label: 'Computer Science with Specialization in Bioinformatics (B.S)'},
  {value: 'Critical Gender Studies (B.A.)', label: 'Critical Gender Studies (B.A.)'},
  {value: 'Data Science (B.S.)', label: 'Data Science (B.S.)'},
  {value: 'Business Economics (B.S.)', label: 'Business Economics (B.S.)'},
  {value: 'Economics (B.A.)', label: 'Economics (B.A.)'},
  {value: 'Economics and Mathematics - Joint Major (B.S.)', label: 'Economics and Mathematics - Joint Major (B.S.)'},
  {value: 'Economics-Public Policy (B.A./MPP only)‡', label: 'Economics-Public Policy (B.A./MPP only)‡'},
  {value: 'Education Sciences (B.S.)', label: 'Education Sciences (B.S.)'},
  {value: 'Computer Engineering (B.S.)', label: 'Computer Engineering (B.S.)'},
  {value: 'Electrical Engineering (B.S.)', label: 'Electrical Engineering (B.S.)'},
  {value: 'Electrical Engineering and Society (B.A.)', label: 'Electrical Engineering and Society (B.A.)'},
  {value: 'Engineering Physics (B.S.)', label: 'Engineering Physics (B.S.)'},
  {value: 'Environmental Systems (B.A/B.S)', label: 'Environmental Systems (B.A/B.S)'},
  {value: 'Ethnic Studies (B.A.)', label: 'Ethnic Studies (B.A.)'},
  {value: 'German Studies (B.A.)', label: 'German Studies (B.A.)'},
  {value: 'Global Health (B.A./B.S.)', label: 'Global Health (B.A./B.S.)'},
  {value: 'Global South Studies (B.A.)', label: 'Global South Studies (B.A.)'},
  {value: 'Public Health (B.S.)', label: 'Public Health (B.S.)'},
  {value: 'History (B.A.)', label: 'History (B.A.)'},
  {value: 'Human Developmental Sciences (B.A./B.S.)', label: 'Human Developmental Sciences (B.A./B.S.)'},
  {value: 'International Studies (B.A.)', label: 'International Studies (B.A.)'},
  {value: 'Italian Studies (B.A.)', label: 'Italian Studies (B.A.)'},
  {value: 'Japanese Studies (B.A.)', label: 'Japanese Studies (B.A.)'},
  {value: 'Jewish Studies (B.A.)', label: 'Jewish Studies (B.A.)'},
  {value: 'Latin American Studies (B.A.)', label: 'Latin American Studies (B.A.)'},
  {value: 'Linguistics (B.A.)', label: 'Linguistics (B.A.)'},
  {value: 'Literatures in English (B.A.)', label: 'Literatures in English (B.A.)'},
  {value: 'Spanish Literature (B.A.)', label: 'Spanish Literature (B.A.)'},
  {value: 'Literature/Writing (B.A.)', label: 'Literature/Writing (B.A.)'},
  {value: 'World Literature and Culture (B.A.)', label: 'World Literature and Culture (B.A.)'},
  {value: 'Mathematics (Applied) (B.S.)', label: 'Mathematics (Applied) (B.S.)'},
  {value: 'Mathematics (B.S.)', label: 'Mathematics (B.S.)'},
  {value: 'Mathematics and Economics - Joint Major (B.S.)', label: 'Mathematics and Economics - Joint Major (B.S.)'},
  {value: 'Mathematics - Applied Science (B.S.)', label: 'Mathematics - Applied Science (B.S.)'},
  {value: 'Mathematics - Computer Science (B.S.)', label: 'Mathematics - Computer Science (B.S.)'},
  {value: 'Mathematics - Secondary Education (B.A.)', label: 'Mathematics - Secondary Education (B.A.)'},
  {value: 'Probability and Statistics (B.S.)', label: 'Probability and Statistics (B.S.)'},
  {value: 'Aerospace Engineering (B.S.)', label: 'Aerospace Engineering (B.S.)'},
  {value: 'Mechanical Engineering (B.S.)', label: 'Mechanical Engineering (B.S.)'},
  {value: 'Music (B.A.)', label: 'Music (B.A.)'},
  {value: 'Interdisciplinary Computing and the Arts (B.A.)', label: 'Interdisciplinary Computing and the Arts (B.A.)'},
  {value: 'Music Humanities (B.A.)', label: 'Music Humanities (B.A.)'},
  {value: 'Chemical Engineering (B.S.)', label: 'Chemical Engineering (B.S.)'},
  {value: 'NanoEngineering (B.S.)', label: 'NanoEngineering (B.S.)'},
  {value: 'Philosophy (B.A.)', label: 'Philosophy (B.A.)'},
  {value: 'General Physics (B.A.)', label: 'General Physics (B.A.)'},
  {value: 'Physics (B.S.)', label: 'Physics (B.S.)'},
  {value: 'Political Science (B.A.)', label: 'Political Science (B.A.)'},
  {value: 'Psychology (B.A./B.S.)', label: 'Psychology (B.A./B.S.)'},
  {value: 'Business Psychology (B.S.)', label: 'Business Psychology (B.S.)'},
  {value: 'Study of Religion (B.A.)', label: 'Study of Religion (B.A.)'},
  {value: 'Russian, East European & Eurasian Studies (B.A.)', label: 'Russian, East European & Eurasian Studies (B.A.)'},
  {value: 'Geosciences (B.S.)', label: 'Geosciences (B.S.)'},
  {value: 'Marine Biology (B.S.)', label: 'Marine Biology (B.S.)'},
  {value: 'Oceanic and Atmospheric Sciences (B.S.)', label: 'Oceanic and Atmospheric Sciences (B.S.)'},
  {value: 'Sociology (B.A.)', label: 'Sociology (B.A.)'},
  {value: 'Structural Engineering (B.S.)', label: 'Structural Engineering (B.S.)'},
  {value: 'Dance (B.A.)', label: 'Dance (B.A.)'},
  {value: 'Theatre (B.A.)', label: 'Theatre (B.A.)'},
  {value: 'Undeclared', label: 'Undeclared'},
  {value: 'Undeclared - Humanities/Arts', label: 'Undeclared - Humanities/Arts'},
  {value: 'Undeclared - Physical Sciences', label: 'Undeclared - Physical Sciences'},
  {value: 'Undeclared - Social Sciences', label: 'Undeclared - Social Sciences'},
  {value: 'Urban Studies and Planning (B.A.)', label: 'Urban Studies and Planning (B.A.)'},
  {value: 'Real Estate and Development (B.S.)', label: 'Real Estate and Development (B.S.)'},
  {value: 'Art History/ Criticism (B.A.)', label: 'Art History/ Criticism (B.A.)'},
  {value: 'Interdisciplinary Computing and the Arts (B.A.)', label: 'Interdisciplinary Computing and the Arts (B.A.)'},
  {value: 'Media (B.A.)', label: 'Media (B.A.)'},
  {value: 'Speculative Design (B.A.)', label: 'Speculative Design (B.A.)'},
  {value: 'Studio (B.A.)', label: 'Studio (B.A.)'}
];